// removed by extract-text-webpack-plugin
module.exports = {"container":"_2q2SKEggkrq-yxrmOqp-dx","bar":"_2A3RtDomXhShlkVrGwhpzX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProgressStatus/ProgressStatus.scss
// module id = 1295
// module chunks = 1